// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1_Ryn","containerItemsCenter":"Skeleton_containerItemsCenter__1G1UC"};